module.exports = __webpack_public_path__ + "static/media/logo.3f657c5a.png";